import React, { useState } from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import dashboardStyles from '../Dashboard.module.scss';
import styles from './Tickets.module.scss';
import { showModal, hideModal } from 'legacy/actions/modalActions';
import TicketModalNew from 'legacy/tickets/components/TicketModalNew';

const Tickets = ({ tickets, device }) => {
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const router = useRouter();
  const { t } = useTranslation('dashboard');

  let displayedTickets = tickets;
  if (device !== 'mobile') {
    displayedTickets = displayedTickets.slice(0, 3);
  }
  const displayedTicketCards = displayedTickets.map((ticket) => {
    if (ticket.event) {
      return (
        <div key={ticket._id}>
          <div
            className="ticket"
            onClick={() => {
              setSelectedTicketId(ticket.event._id);
            }}
          >
            <div>
              <div
                className="pic"
                style={{
                  backgroundImage: `url(${
                    ticket.event.photo && ticket.event.photo.url
                      ? ticket.event.photo.url
                      : '/img/defaultPhoto.svg'
                  })`,
                  backgroundSize: 'cover'
                }}
              />
              <div style={{ WebkitBoxOrient: 'vertical' }} className="details">
                {ticket.event.title}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  });

  return (
    <div className={classnames('bn-container', [styles.Tickets], device)}>
      <div className={dashboardStyles.cardHeader}>
        <span className={dashboardStyles.cardTitle}>{t('tickets.title')}</span>
      </div>
      <div className="content">
        <div className="section tickets">
          {displayedTicketCards}
          {displayedTicketCards.length < 3 && (
            <div className="join-nearby">
              {tickets.length === 0 ? (
                <div>
                  <div>
                    <span>{t('tickets.noTicketsYet')}</span>
                    <p>{t('tickets.joinEventNearby')}</p>
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <p>{t('tickets.checkNearbyEvents')}</p>
                  </div>
                </div>
              )}
            </div>
          )}
          {tickets.length > 3 && device !== 'mobile' && (
            <div
              className="view-all cursor-pointer"
              onClick={() => {
                router.push('/tickets');
              }}
            >
              {t('tickets.viewAll')}
            </div>
          )}
        </div>
      </div>

      {selectedTicketId && (
        <TicketModalNew
          showViewEventButton
          eventId={selectedTicketId}
          onClose={() => setSelectedTicketId(null)}
        />
      )}
    </div>
  );
};

export default connect(null, { showModal, hideModal })(Tickets);
